// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.nav-tabs .nav-link {
    /* color: darkgray !important; */
    color: rgba(33, 37, 41, 0.65) !important;
    font-size: 0.9rem;
  }


  
  .nav-tabs .nav-link.active {
    /* color: black !important; */
    /* color: yellow !important; */
    font-weight: 700;
    /* background-color: rgb(101, 100, 100) !important; */
    color: white !important;
    background-color:#0d6efd !important;
  }

  .nav-tabs .nav-link:hover {
    
    font-weight: 900;
    /* color: rgb(255, 255, 255) !important;
    background-color: #0d6efd !important; */

    color: #0d6efd !important;
    background-color: rgb(255, 255, 255) !important;

  }


/* .hidden {
    display:none;
} */

.confirmation-text {
    font-size: 1.4rem;
    list-style-type: none;
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
}

.alert-title-black {
    color: black;
    font-weight: bold;
    font-size: 1.3em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":";;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,iBAAiB;EACnB;;;;EAIA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;IAChB,qDAAqD;IACrD,uBAAuB;IACvB,mCAAmC;EACrC;;EAEA;;IAEE,gBAAgB;IAChB;2CACuC;;IAEvC,yBAAyB;IACzB,+CAA+C;;EAEjD;;;AAGF;;GAEG;;AAEH;IACI,iBAAiB;IACjB,qBAAqB;IACrB,UAAU,EAAE,mBAAmB;IAC/B,SAAS,EAAE,mBAAmB;AAClC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["\n\n.nav-tabs .nav-link {\n    /* color: darkgray !important; */\n    color: rgba(33, 37, 41, 0.65) !important;\n    font-size: 0.9rem;\n  }\n\n\n  \n  .nav-tabs .nav-link.active {\n    /* color: black !important; */\n    /* color: yellow !important; */\n    font-weight: 700;\n    /* background-color: rgb(101, 100, 100) !important; */\n    color: white !important;\n    background-color:#0d6efd !important;\n  }\n\n  .nav-tabs .nav-link:hover {\n    \n    font-weight: 900;\n    /* color: rgb(255, 255, 255) !important;\n    background-color: #0d6efd !important; */\n\n    color: #0d6efd !important;\n    background-color: rgb(255, 255, 255) !important;\n\n  }\n\n\n/* .hidden {\n    display:none;\n} */\n\n.confirmation-text {\n    font-size: 1.4rem;\n    list-style-type: none;\n    padding: 0; /* Remove padding */\n    margin: 0; /* Remove margins */\n}\n\n.alert-title-black {\n    color: black;\n    font-weight: bold;\n    font-size: 1.3em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
